module.exports = __webpack_public_path__ + "img/brand-01.4f34330a.png";